{
	"cardHeader": "Accedi alle tue dichiarazioni",
	"supplierTitle": "Sei il fornitore di una dichiarazione evoZero?",
	"supplierDescription": "Gestisci le dichiarazioni per i tuoi materiali evoZero.",
	"loginButton": "Accedi"
}
